const editableMatchStats = {
/*  baseball: [
    'outs',
    'errors',
    'hits',
  ], */
}

export { editableMatchStats }
